/**
 * Route for the partner OAuth consent screen.
 *
 * Lives in its own module because two places need it and they must not drift:
 * `Routes` registers it, and `App` exempts it from the already-logged-in
 * redirect. Consent is the one page here that *requires* a session instead of
 * establishing one — sending a signed-in user away from it breaks the flow.
 *
 * Estuary redirects the browser to `${LOGIN_URL}${CONSENT_PATH}?challenge=<jwt>`.
 */
export const CONSENT_PATH = '/oauth/consent';

export function isConsentPath(pathname: string): boolean {
  return pathname === CONSENT_PATH || pathname.startsWith(`${CONSENT_PATH}/`);
}
